import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { popUpStatuses, popUpStatusesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import {
    DateColumnFilter,
    DateRangeColumnFilter,
    DebouncedRangeColumnFilter,
    rowIndexColumn,
    SelectColumnFilter,
} from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import { getOrganizationNames } from "sources/admin";
import { activate, putToArchive, restore, returnToDraft } from "sources/books/popups";

export class Popups extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "header",
                filterable: true,
                Cell: ({ value, row: { original } }) => {
                    const { id } = original;
                    return <Link to={paths.popupsShow(id)}>{value}</Link>;
                },
            },
            {
                Header: "Статус",
                accessor: "status",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "status" },
                            options: popUpStatuses,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(popUpStatuses, value),
                CSVExport: ({ value }) => enumLabel(popUpStatuses, value),
            },
            {
                Header: "Организации",
                accessor: "organizations",
                id: "organizationIds",
                sortable: false,
                filterable: true,
                filterType: "arrayContainsWithEmpty",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationIds" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({ value }) => (value?.length ? value.join(", ") : "Всем организациям"),
            },
            {
                Header: "Без возможности закрытия",
                accessor: "noWayToClose",
                sortable: false,
                width: 150,
                Cell: ({ value }) => <div className="text-center">{value ? "Да" : "Нет"}</div>,
                CSVExport: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Количество показов",
                accessor: "receivedCount",
                filterable: true,
                filterType: "numberRange",
                Filter: DebouncedRangeColumnFilter,
            },
            {
                Header: "Количество просмотров",
                accessor: "viewedCount",
                filterable: true,
                filterType: "numberRange",
                Filter: DebouncedRangeColumnFilter,
            },
            {
                Header: "Дата блокировки организации",
                accessor: "organizationBlockDate",
                filterable: true,
                Filter: DateRangeColumnFilter,
                filterType: "dateRange",
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Дата активации",
                accessor: "activatedAt",
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Дата редактирования",
                accessor: "updatedAt",
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Дата удаления",
                accessor: "deletedAt",
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "",
                accessor: "actions",
                sortable: false,
                notExportable: true,
                Cell: ({ row }) => {
                    const { status, id } = row.original;
                    return (
                        <div>
                            {status === popUpStatusesEnum.Draft && (
                                <div
                                    className="btn btn-xs btn-outline-primary mr-2 mb-1"
                                    onClick={() => this.action(activate, id)}
                                >
                                    Активировать
                                </div>
                            )}
                            {status === popUpStatusesEnum.Draft && (
                                <div
                                    className="btn btn-xs btn-outline-danger mr-2"
                                    onClick={() => this.action(putToArchive, id)}
                                >
                                    Архивировать
                                </div>
                            )}
                            {status === popUpStatusesEnum.Active && (
                                <div
                                    className="btn btn-xs btn-secondary mr-2"
                                    onClick={() => this.action(returnToDraft, id)}
                                >
                                    Вернуть в черновик
                                </div>
                            )}
                            {status === popUpStatusesEnum.Archived && (
                                <div
                                    className="btn btn-xs btn-outline-success mr-2"
                                    onClick={() => this.action(restore, id)}
                                >
                                    Восстановить
                                </div>
                            )}
                        </div>
                    );
                },
            },
        ];
    }

    action = (action, id) => {
        this.props.modal({
            name: "confirm",
            title: "Подтвердите действие",
            buttons: { confirm: "Да", cancel: "Нет" },
            action: () => action({ id }).then(() => this.props.mergeParams({})),
        });
    };

    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} />
                    <div className="book-list__head-title">
                        {this.props.title}
                        {this.renderCounter()}
                    </div>
                    <div className="btn-toolbar">{this.renderCreateButton()}</div>
                </div>
            </div>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(Popups, "popups");
